import 'react';
import { Button } from 'reaxl';
import { jsx } from 'react/jsx-runtime';
function OfferBreakdownCTA(_ref) {
  let {
    callback = () => {},
    label = 'Offer Breakdown'
  } = _ref;
  const handleClick = event => {
    callback(event);
  };
  return /*#__PURE__*/jsx(Button, {
    "data-cmp": "offerBreakdownCTA",
    className: "text-nowrap",
    bsStyle: "text",
    onClick: handleClick,
    children: label
  });
}
export { OfferBreakdownCTA as default };
